/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ConfigRevision, NodeConfig } from '@/client';
import { CardCollapse } from '@/components/CardCollapse';
import { SelectedConfigRevisionCard } from '@/components/ConfigWizardOverlay/SelectedConfigRevisionCard';
import { SelectedNodeConfigCard } from '@/components/ConfigWizardOverlay/SelectedNodeConfigCard';

export type UpdateFleetConfigReviewStepProps = {
  newConfig: NodeConfig;
  newRevision: ConfigRevision;
  onChangeConfig: () => void;
  onChangeRevision: () => void;
};

export function UpdateFleetConfigReviewStep({
  newConfig,
  newRevision,
  onChangeConfig,
  onChangeRevision,
}: UpdateFleetConfigReviewStepProps) {
  return (
    <CardCollapse>
      <SelectedNodeConfigCard nodeConfig={newConfig} onChangeClick={onChangeConfig} />
      <SelectedConfigRevisionCard configRevision={newRevision} onChangeClick={onChangeRevision} />
    </CardCollapse>
  );
}
